import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import BadgeImg from '../../assets/images/FramedImage.png';
import Logomark from '../../assets/images/Logomark.png';
import { ROUTES } from 'src/constants/routes';
import Container from '../Container';
import { Box } from '@mui/material';

export const UploadSuccess = () => {
  return (
    <Container smPaddings={true}>
      <ConfirmationWithBackButton
        title="Your policy is in review"
        subtitle="Thank you for linking your renters insurance policy, we kindly request your patience and we will contact you and your landlord after reviewing."
        image={BadgeImg}
        goBackLink={ROUTES.COMPLIANCE_WELCOME_PATH}
        bottomMessage={(
          <Box mt={4}>
            <MessageBox
              image={Logomark}
              title="Still have question?"
            />
          </Box>
        )}
      />
    </Container>
  );
};
